import gql from 'graphql-tag';

export const GET_CAMPAIGN = '';

export const SEND_PUSH_NOTIFICATIONS = gql`
  mutation SendPushNotifications(
    $campaignId: String!
    $title: String!
    $message: String!
  ) {
    sendPushNotifications(
      campaignId: $campaignId
      input: { title: $title, message: $message }
    ) {
      notificationsSent
    }
  }
`;
